<template>
  <div>
    <CRow v-if="notEmpty" class="g-3"> <!-- Adds gap between rows -->
      <CCol
        v-for="(project, index) in projects"
        :key="index"
        :md="6"
        :lg="6"
        :xl="4"
        :xxl="3"
      >
        <CCard border-color="dark"
          class="cursor-pointer hover-card"
          @click="showProject(project)"
        >
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0 text-ellipsis">
              <CIcon name="cil-briefcase" class="me-2" /> {{ project.project }}
            </h5>
            <CBadge :color="statusColor(project.status)">
              <CIcon :name="statusIcon(project.status)" class="me-1" />
              {{ project.status }}
            </CBadge>
          </CCardHeader>
          <CCardBody class="m-0 pt-1 pb-1">
            <CRow class="mb-1 p-0">

              <CCol>
                <CIcon name="cil-user" class="mr-2" /><strong>{{ project.who }}</strong>
              </CCol>

              <CCol>
                <CIcon name="cil-calendar" class="mr-2" />{{ project.stop }}
                <CBadge v-if="isOverdue(project)" color="danger" class="ms-2">Overdue</CBadge>
              </CCol>

              <CCol lg="3">
                <CIcon name="cil-flag-alt" class="mr-2" />
                <CBadge class="ml-1 mr-0" :color="priorityColor(project.priority)">
                  {{ project.priority }}
                </CBadge>
              </CCol>

            </CRow>
            <CRow v-if="project.note" class="mb-1 p-0">
              <CCol>
                <CIcon name="cil-info" class="mr-2" /> {{project.note}}
              </CCol>
            </CRow>

            <CRow v-if="noteContent(project)" class="align-items-center">
              <CCol>
                <CIcon name="cib-marketo" class="mr-2"/>
                <CBadge class="text-left" style="white-space: pre-line;" color="warning">
                  {{noteContent(project)}}
                </CBadge>
              </CCol>
            </CRow>

          </CCardBody>
          <CCardFooter class="m-0 pt-1 pb-2">
            <small class="text-muted">
              <CIcon name="cil-clock" class="me-0" />
              Cập nhật cuối: <strong>{{ project.updated }}</strong>
            </small>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <!-- Display a message if no projects -->
    <div v-else class="text-center py-5 no-projects-message">
      <h2 class="mt-3">Không tồn tại dự án</h2>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      projects: [],
    };
  },
  created() {
    if(localStorage.getItem('role') === 'monitor'){
      this.$router.push({path: '/device'});
    } else if (localStorage.getItem('role') === 'customer') {
      this.$router.push({path: '/customer'});
    } else {
      this.getAll();
    }
  },
  computed: {
    notEmpty() {
      return this.projects && this.projects.length > 0;
    },
  },
  methods: {
    logout() {
      this.$logout()
    },
    getAll() {
      this.$request.get(`/api/project`).then(res => {
        // Filter out completed projects and 'Bảo Hành - Bảo Trì' project
        this.projects = res.data.projects.filter(project => 
          project.status !== 'Hoàn thành' && project.project !== 'Bảo Hành - Bảo Trì'
        )
      }).catch((error) => {
        // console.log(error, 'exit...!');
        this.logout()
      })
    },
    showProject(project) {
      this.$router.push({
        path: `/project/mod`,
        query: {
          id: project.id,
        }
      })
    },
    isOverdue(project) {
      const today = new Date();
      const deadline = new Date(project.time);
      return today > deadline;
    },
    statusColor(status) {
      switch (status) {
        case "Đang thực hiện":
          return "success";
        case "Sắp quá hạn":
          return "warning";
        case "Quá hạn":
          return "danger";
        case "Hoàn thành":
          return "primary";
        default:
          return "secondary";
      }
    },
    statusIcon(status) {
      switch (status) {
        case "Đang thực hiện":
          return "cil-running";
        case "Tạo mới":
          return "cil-media-pause"
        case "Quá hạn":
          return "cil-warning";
        case "Hoàn thành":
          return "cil-task";
        default:
          return "cil-info";
      }
    },
    priorityColor(priority) {

      if(priority <= 0) {
        return "danger";
      }
      if(priority === 1) {
        return "warning";
      }
      if (priority === 2 || priority === 3) {
        return "success";
      }
      return "secondary"
    },
    noteContent(project) {
      let note = ''
      if (project.design_note) {
        note += `Thiết kế: ${project.design_note}\n`;
      }
      if (project.material_note) {
        note += `Vật tư: ${project.material_note}\n`;
      }
      if (project.manufacture_note) {
        note += `Sản xuất: ${project.manufacture_note}`;
      }
      return note
    },
  },
};
</script>

<style scoped>
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cursor-pointer {
  cursor: pointer;
}

.no-projects-message {
  display: flex;
  margin-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: gray; /* Gray color for text */
  font-weight: bold; /* Bold font weight */
}

.no-projects-message h4 {
  font-size: 4rem; /* Scaling the title */
}

.no-projects-message p {
  font-size: 1.5rem; /* Scaling the description text */
}

.hover-card {
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-card:hover {
  transform: scale(1.05); /* Slightly enlarge the card */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow effect */
}

.hover-message {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7); /* Semi-transparent black background */
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
}

.hover-card:hover .hover-message {
  display: block;
}


</style>
